import {useHistory} from '@aboutyou/router';
import {useEffect, useState} from 'react';
import {LocationState, OPENED_STATE_KEY_PREFIX} from './useOpenedStateManager';

export const useIsAnyOverlayOpen = (excludeKey?: string) => {
  const history = useHistory();
  const [locationState, setLocationState] = useState<LocationState>({});

  useEffect(() => {
    const unsubscribe = history.listen(location => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setLocationState(location.state as LocationState);
    });
    return unsubscribe;
  }, []);

  if (!locationState) {
    return false;
  }

  const keys = Object.keys(locationState);

  return keys.some(key => {
    if (key.includes(OPENED_STATE_KEY_PREFIX)) {
      if (excludeKey) {
        return !key.includes(excludeKey);
      }
      return true;
    }
    return false;
  });
};
